import axios from 'axios';
import {
  GET_CAMPAIGN_DATA_REQUEST,
  GET_CAMPAIGN_DATA_SUCCESS,
  GET_CAMPAIGN_DATA_FAILURE,

  GET_CAMPAIGN_DETAIL_REQUEST,
  GET_CAMPAIGN_DETAIL_SUCCESS,
  GET_CAMPAIGN_DETAIL_FAILURE,

  CAMPAIGN_JOIN_SUCCESS,

  CHECK_CAMPAIGN_JOIN_REQUEST,
  CHECK_CAMPAIGN_JOIN_SUCCESS,
  CHECK_CAMPAIGN_JOIN_FAILURE,

  SET_CAMPAIGN_KVKK_STATE,

  GET_CAMPAIGN_RESULT_REQUEST,
  GET_CAMPAIGN_RESULT_SUCCESS,
  GET_CAMPAIGN_RESULT_FAILURE,
  GET_USER_CAMPAIGN_RESULT_REQUEST,
  GET_USER_CAMPAIGN_RESULT_SUCCESS,
  GET_USER_CAMPAIGN_RESULT_FAILURE,
  GET_CAMPAIGN_PRIZE_REQUEST,
  GET_CAMPAIGN_PRIZE_SUCCESS,
  GET_CAMPAIGN_PRIZE_FAILURE,
} from 'Store/constants';
import {
  openModal,
  closeModal
} from 'Store/actions';

import errorMessage from './errorMessage';

export const setCampaignKVKKState = (isChecked, closeKVKKModal = false) => async (dispatch, getState) => {
  dispatch({
    type: SET_CAMPAIGN_KVKK_STATE,
    isKVKKchecked: isChecked
  });

  if (closeKVKKModal) {
    dispatch(closeModal('KVKKModal'));
  }
};

export const getCampaigns = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CAMPAIGN_DATA_REQUEST
    });

    let res, resPassive;

    if (getState().auth.isAuthenticated) {
      res = await axios.get('/campaigns/active');
    } else {
      res = await axios.get('/campaigns/public/active');
    }

    if (getState().auth.isAuthenticated) {
      resPassive = await axios.get('/campaigns/passives');
    } else {
      resPassive = await axios.get('/campaigns/public/passives');
    }
   
    const campaigns = res.data.campaigns;
    const passiveCampaigns = resPassive.data.passiveCampaigns;

    dispatch({
      type: GET_CAMPAIGN_DATA_SUCCESS,
      payload: campaigns.concat(passiveCampaigns)
    });
  } catch (e) {

    dispatch({
      type: GET_CAMPAIGN_DATA_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const getCampaignById = id => async (dispatch, getState) => {
  try {

    dispatch({
      type: GET_CAMPAIGN_DETAIL_REQUEST
    });

    let res;

    if (getState().auth.isAuthenticated) {
      try {
        res = await axios.get(`/campaigns/active/${id}/detail`);
      } catch (authErr) {
        if (authErr.response?.status === 401) {
          res = await axios.get(`/campaigns/public/active/${id}/detail`);
        } else {
          throw authErr;
        }
      }
    } else {

      res = await axios.get(`/campaigns/public/active/${id}/detail`);
    }

    dispatch({
      type: GET_CAMPAIGN_DETAIL_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_CAMPAIGN_DETAIL_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const checkCampaignJoinInfo = id => async (dispatch, getState) => {
  if (!getState().auth.isAuthenticated) {
    return;
  }

  try {

    dispatch({
      type: CHECK_CAMPAIGN_JOIN_REQUEST
    });

    const res = await axios.get(`/campaigns/join/check?campaignId=${id}`);

    dispatch({
      type: CHECK_CAMPAIGN_JOIN_SUCCESS,
      payload: {
        [id]: res.data?.joinInfo?.isJoined
      }
    });

  } catch (e) {

    dispatch({
      type: CHECK_CAMPAIGN_JOIN_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const joinCampaign = (joinData, campaignType) => async dispatch => {
  try {

    const res = await axios.post('/campaigns/join', joinData);

    switch (campaignType) {
      case 'GIVE_CODE': {
        const { code, vendorName } = res.data.joinInfo;
        dispatch(openModal('giveCode', { code, vendorName }));
        break;
      }
      case 'USE_CODE': {
        const { ticketType } = res.data.joinInfo;
        dispatch(openModal('loadCodeSuccess', { ticketType }));
        break;
      }
      case 'WITHDRAW': {
        dispatch(openModal('joinSuccess', { data: res.data }));
        break;
      }
    }

    dispatch(getCampaignById(joinData.campaignId));

    dispatch({
      type: CAMPAIGN_JOIN_SUCCESS
    });

    // add registered campaigns to registeredCampaigns reducer directly
    dispatch({
      type: CHECK_CAMPAIGN_JOIN_SUCCESS,
      payload: {
        [joinData.campaignId]: true
      }
    });
  } catch (e) {
    const { data } = e.response || {};

    switch (campaignType) {
      case 'GIVE_CODE': {
        dispatch(openModal('joined', { error: data }));
        break;
      }
      case 'USE_CODE': {
        dispatch(openModal('loadCodeFailure', { errorMessage: data && data.message }));
        break;
      }
      case 'WITHDRAW': {
        if (data && data.code === 4026) {
          dispatch(openModal('joinFailure', { error: data }));
        } else {
          dispatch(openModal('joined', { error: data }));
        }
        break;
      }
    }
  }
};


export const cancelCampaign = ({ campaignId, cancelChannel }) => async () => {
  try {
    await axios.post('/campaigns/join/cancel', { campaignId, cancelChannel });
  } catch (error) {
    //console.log('error while canceling campaign', error);
  }
};

export const getCampaignResult = campaignId => async dispatch => {
  try {
    dispatch({
      type: GET_CAMPAIGN_RESULT_REQUEST,
    });

    const res = await axios.get(`/cms/campaign/result?campaign_id=${campaignId}`);

    dispatch({
      type: GET_CAMPAIGN_RESULT_SUCCESS,
      payload: res.data,
    });
  } catch (e) {

    dispatch({
      type: GET_CAMPAIGN_RESULT_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const getUserCampaignResult = campaignId => async dispatch => {
  try {
    dispatch({
      type: GET_USER_CAMPAIGN_RESULT_REQUEST,
    });

    const res = await axios.get(`/campaigns/results/draw-codes/${campaignId}`);

    dispatch({
      type: GET_USER_CAMPAIGN_RESULT_SUCCESS,
      payload: res.data,
    });
  } catch (e) {

    dispatch({
      type: GET_USER_CAMPAIGN_RESULT_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const getCampaignPrize = campaignId => async dispatch => {
  try {
    dispatch({
      type: GET_CAMPAIGN_PRIZE_REQUEST,
    });

    const res = await axios.get(`/campaigns/content-prize/${campaignId}`);

    dispatch({
      type: GET_CAMPAIGN_PRIZE_SUCCESS,
      payload: res.data,
    });
  } catch (e) {

    dispatch({
      type: GET_CAMPAIGN_PRIZE_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};